import { createContext, useContext } from "react";

import { useUnassignedAccountController } from "./index";

interface ControllerContextProviderProps {
  children: React.ReactNode;
}

type TControllerContextValue = ReturnType<
  typeof useUnassignedAccountController
>;

const ControllerContext = createContext<TControllerContextValue>(
  {} as TControllerContextValue
);

const UnassignedAccountControllerContextProvider = ({
  children,
}: ControllerContextProviderProps) => {
  const props = useUnassignedAccountController();

  return (
    <ControllerContext.Provider value={props}>
      {children}
    </ControllerContext.Provider>
  );
};

export const useUnassignedAccountControllerContext = () =>
  useContext(ControllerContext);
export default UnassignedAccountControllerContextProvider;
